import { clearTokens, setTokens, STORAGE_KEYS } from "../api/http.js";

export { STORAGE_KEYS };

export function phoneDigitsNational(phone) {
  const d = String(phone || "").replace(/\D/g, "");
  if (!d) return "";
  if (d.startsWith("8")) return `7${d.slice(1, 11)}`;
  if (d.startsWith("7")) return d.slice(0, 11);
  return `7${d.slice(0, 10)}`;
}

export function normalizePhoneDigits(phone) {
  return phoneDigitsNational(phone);
}

export function hasMarketplaceJwtCredentials() {
  return !!(
    localStorage.getItem(STORAGE_KEYS.ACCESS) || localStorage.getItem(STORAGE_KEYS.REFRESH)
  );
}

export function saveMarketplaceTokens({ access, refresh, phone } = {}) {
  setTokens(access || null, refresh || null);
  if (phone) {
    localStorage.setItem(
      "wicoop_vitrine_session_v1",
      JSON.stringify({ phone: phoneDigitsNational(phone) }),
    );
  }
}

export function clearWicoopSession() {
  clearTokens();
  localStorage.removeItem("wicoop_vitrine_session_v1");
  localStorage.removeItem("wicoop_global_profile_v1");
  localStorage.removeItem("wicoop_giveaway_tokens_v1");
  clearTelegramWebAppSessionFlag();
  for (let i = localStorage.length - 1; i >= 0; i -= 1) {
    const key = localStorage.key(i);
    if (key && key.startsWith("wicoop_phone_proof_v1_")) {
      localStorage.removeItem(key);
    }
  }
}

export function readGlobalProfile() {
  const raw = localStorage.getItem("wicoop_global_profile_v1");
  if (!raw) return null;
  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export function saveGlobalProfile(profile) {
  if (!profile || typeof profile !== "object") {
    localStorage.removeItem("wicoop_global_profile_v1");
    return;
  }
  localStorage.setItem("wicoop_global_profile_v1", JSON.stringify(profile));
}

export function writeGlobalProfile(profile) {
  saveGlobalProfile(profile);
}

export function cacheGlobalProfileFromAccountMe(me) {
  if (!me || typeof me !== "object") return;
  const prev = readGlobalProfile() || {};
  saveGlobalProfile({
    ...prev,
    phone: me.phone ?? prev.phone,
    email: me.email ?? prev.email,
    first_name: me.first_name ?? prev.first_name,
    last_name: me.last_name ?? prev.last_name,
    middle_name: me.middle_name ?? me.patronymic ?? prev.middle_name ?? prev.patronymic,
    sbp_bank_id: me.sbp_bank_id ?? prev.sbp_bank_id,
  });
}

export function readVitrineSession() {
  const raw = localStorage.getItem("wicoop_vitrine_session_v1");
  if (!raw) return null;
  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export function isVitrineLoggedIn() {
  if (hasMarketplaceJwtCredentials()) return true;
  const gp = readGlobalProfile();
  if (gp?.phone && gp?.first_name && gp?.last_name) return true;
  const vs = readVitrineSession();
  if (vs?.phone) return true;
  return false;
}

export function readGiveawayTokens() {
  const raw = localStorage.getItem("wicoop_giveaway_tokens_v1");
  if (!raw) return {};
  try {
    const o = JSON.parse(raw);
    return o && typeof o === "object" ? o : {};
  } catch {
    return {};
  }
}

export function saveTokenForGiveaway(giveawayId, token) {
  const map = readGiveawayTokens();
  map[String(giveawayId)] = token;
  localStorage.setItem("wicoop_giveaway_tokens_v1", JSON.stringify(map));
}

export function readTokenForGiveaway(giveawayId) {
  const map = readGiveawayTokens();
  return map[String(giveawayId)] || null;
}

const TG_SESSION_FLAG = "wicoop_telegram_webapp_session_v1";

export function clearTelegramWebAppSessionFlag() {
  localStorage.removeItem(TG_SESSION_FLAG);
}

export function setTelegramWebAppSessionFlag() {
  localStorage.setItem(TG_SESSION_FLAG, "1");
}

export function isTelegramWebAppSession() {
  return localStorage.getItem(TG_SESSION_FLAG) === "1";
}

export function clearMaxWebAppSessionFlag() {
  /* Telegram-only app */
}
